import React, { useEffect, useState } from "react";
import { MdArrowBack, MdDelete, MdErrorOutline, MdAdd } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Container from "../../base/Container";
import Card from "../../controls/Card";
import { GetAllByUser, Remove } from "../../../configurations/crud/opdCentersCrud";
import LoadingContainer from "../../controls/LoadingContainer";
import StatusContainer from "../../controls/StatusContainer";
import { CiLocationArrow1 } from "react-icons/ci";
import {
  EDoctorStatusBg,
  GetEDoctorStatusName,
} from "../../../configurations/enums/EDoctorStatus";
import { RiEditBoxFill } from "react-icons/ri";
import DeleteCenterModal from "./DeleteCenterModal";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { GetEOpdDaysName } from "../../../configurations/enums/EOpdDays";
import { EOPDCenterStatusBg, GetEOPDCenterStatusName } from "../../../configurations/enums/EOPDCenterStatus";
import useGlobalLoader from "../../../configurations/useGlobalLoader";
import { EBoolBg, GetEBoolName } from "../../../configurations/enums/EBool";
import { EDayTypeBg, GetETypeDays } from "../../../configurations/enums/EOpdType";

export default function CenterAllByUser() {
  const { start, end } = useGlobalLoader()
  const navigate = useNavigate()
  const [opdCenters, setOpdCenter] = useState([]);
  const [user, setUser] = useState();
  const [loding, setLoding] = useState(false);
  const toast = useToast();
  const [lodingCrud, setLodingCrud] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [editData, setEditData] = useState({
    id: 0,
    name: "",
    shortName: "",
    priority: "0",
  });

  useEffect(() => {
    getAllOpdCenters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getAllOpdCenters() {
    setLoding(true);
    start()
    GetAllByUser()
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          if (mdata.data.length > 0)
            setUser(mdata.data[0].user);
          setOpdCenter(mdata.data);
        } else {
          setOpdCenter([]);
          toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setOpdCenter([]);
        setLoding(false);
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }

  const doRefresh = () => {
    getAllOpdCenters();
  };

  const handleDelete = (id) => {
    setLodingCrud(true)
    start()
    Remove(id).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setIsOpenDelete(false)
        doRefresh()
        toast.open("Center deleted successfully.", <IoCheckmarkDoneCircleOutline />, "success")
      } else {
        toast.open("You can not delete those centers which are consume by other task", <MdErrorOutline />, "danger")
      }
      setLodingCrud(false)
      end()
    }).catch(errors => {
      setLodingCrud(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    <Container
      heading={
        <>
          Profile <CiLocationArrow1 />
        </>
      }
    >
      <div className="flex w-full flex-col px-2 sm:px-4">

        {/* Add */}
        <div className="mb-3">
          <Link
            to="/opdcenters/add"
            className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-b from-brand-400 to-brand-500 px-4 py-2 text-sm font-semibold text-white shadow-brand transition hover:brightness-105 active:scale-95"
          >
            <MdAdd className="text-lg" /> Add Center
          </Link>
        </div>

        {!loding ? (
          <>
            <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-2">
              {opdCenters.map((item, index) => (
                <Card
                  key={index}
                  isBorder={true}
                  borderColor="border-green-300"
                  title={
                    <div className="flex w-full items-center justify-between gap-2">
                      <span className="truncate">{item.centerName}</span>
                      <span className="text-xs font-normal text-gray-400">#{item.id}</span>
                    </div>
                  }
                >
                  {/* status badges */}
                  <div className="mb-3 flex items-center justify-center flex-wrap gap-1">
                    <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} ml="" />
                    <StatusContainer bg={EOPDCenterStatusBg(item.status)} text={GetEOPDCenterStatusName(item.status)} ml="" />
                    <StatusContainer bg={EBoolBg(item.isRegisterOnline)} text={"Reg Online: " + GetEBoolName(item.isRegisterOnline)} ml="" />
                    <StatusContainer bg={EDayTypeBg(item.opdType)} text={GetETypeDays(item.opdType)} ml="" />
                  </div>

                  {/* details */}
                  <div className="divide-y divide-gray-50 rounded-xl ring-1 ring-gray-100">
                    <InfoRow label="Register Appointment">
                      {moment(item.startPuttingAppointment).format("LT")} - {moment(item.endPuttingAppointment).format("LT")}
                    </InfoRow>
                    <InfoRow label="OPD Timing">
                      {moment(item.opdStartTime).format("LT")} - {moment(item.opdEndTime).format("LT")}
                    </InfoRow>
                    <InfoRow label="Patient Late Count">{item.moveLateCount}</InfoRow>
                    <InfoRow label="Open">
                      <div className="flex flex-wrap gap-1">
                        {item.opdDays.split(',').map((d, i) => (
                          <span key={i} className="rounded-md bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700">
                            {GetEOpdDaysName(d.trim())}
                          </span>
                        ))}
                      </div>
                    </InfoRow>
                    <InfoRow label="Address">
                      {item.address}, {item.city.name}, {item.city.state.name} · Phone {item.phone}
                    </InfoRow>
                    {item.details && <InfoRow label="Details">{item.details}</InfoRow>}
                    <InfoRow label="Per Day OPD Limit">{item.perDayOPDLimit}</InfoRow>
                    <InfoRow label="Days Count">{item.byDaysCount}</InfoRow>
                  </div>

                  {/* actions */}
                  <div className="mt-3 flex justify-end gap-2 border-t border-gray-100 pt-3">
                    <Link
                      to={"/opdcenters/" + item.id + "/edit"}
                      title="Edit"
                      className="grid h-9 w-9 place-items-center rounded-lg text-brand-600 transition hover:bg-brand-50 active:scale-95"
                    >
                      <RiEditBoxFill className="text-xl" />
                    </Link>
                    <button
                      type="button"
                      title="Delete"
                      onClick={() => { setEditData(item); setIsOpenDelete(!isOpenDelete); }}
                      className="grid h-9 w-9 place-items-center rounded-lg text-red-600 transition hover:bg-red-50 active:scale-95"
                    >
                      <MdDelete className="text-xl" />
                    </button>
                  </div>
                </Card>
              ))}
            </div>

            <DeleteCenterModal
              handleDelete={handleDelete}
              isOpen={isOpenDelete}
              setIsOpen={setIsOpenDelete}
              loding={lodingCrud}
              id={editData.id}
              name={editData.centerName}
            />
          </>
        ) : (
          <div className="w-full">
            <LoadingContainer text={"Getting centers"} />
          </div>
        )}
      </div>
    </Container>
  );
}

/* ---------- helper ---------- */
function InfoRow({ label, children }) {
  return (
    <div className="flex flex-col gap-0.5 px-3 py-2 sm:flex-row sm:gap-2">
      <div className="text-xs font-semibold uppercase tracking-wide text-gray-400 sm:w-2/5 sm:shrink-0">{label}</div>
      <div className="text-sm text-gray-700 sm:w-3/5">{children}</div>
    </div>
  );
}